import React from 'react';

const HeaderLogo = () => (
    <a href="https://www.wijzijnumbrella.nl" title="Home" className="c-header__logo" aria-label="Home">
        <span className="u-hidden">Home</span>
    </a>
);

export default HeaderLogo;